module.exports = __webpack_public_path__ + "a1b79adb2630065f14eb2f146838ba67.jpg";